var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#printer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 18.857h3.429a1.714 1.714 0 0 0 1.714-1.714V9.429a1.714 1.714 0 0 0-1.714-1.715H2.57A1.714 1.714 0 0 0 .857 9.43v7.714a1.714 1.714 0 0 0 1.714 1.714H6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16.286v6a.857.857 0 0 0 .857.857h10.286a.857.857 0 0 0 .857-.857v-6zm12-8.572v-6a.857.857 0 0 0-.857-.857H6.857A.857.857 0 0 0 6 1.714v6M18.857 12h-1.714"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "printer_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPrinter;